import styles from "./Input.module.css";

const Form = ({ onSubmit, noValidateFlag, children }) => {
  return (
    <form
      className={styles.formInputDiv}
      onSubmit={onSubmit}
      noValidate={noValidateFlag}
    >
      {children}
    </form>
  );
};

export default Form;
